export default __webpack_public_path__ + "static/media/tileset.bce8ab10.png";